import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import EnhancedCard from "common/components/EnhancedCard";
import QuickLinksList from "core/QuickLinks/List";
import Resource from "common/components/Resource";
import { connect } from "react-redux";
import { urlResource } from "common/utils";

const QuickLinkListing = ({ resource, history }) => (
  <EnhancedCard title="Quick Links" style={{ position: "relative" }}>
    <Resource
      name="quick_link_master"
      queryParams={{}}
      error={() => <Typography>Could not load quick links</Typography>}
      render={(data, { removeOne }) => (
        <QuickLinksList
          quickLinks={data || []}
          data={data}
          removeOne={removeOne}
          isSuperAdmin
        />
      )}
    />
  </EnhancedCard>
);

QuickLinkListing.propTypes = {
  resource: PropTypes.shape({
    id: PropTypes.number.isRequired,
    singular: PropTypes.string.isRequired,
    plural: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

const mapStateToProps = (state, { match }) => ({
  resource: urlResource(match.path),
});

export default connect(mapStateToProps)(QuickLinkListing);
